export const ProjectDocTypeVals = {
  TS: 1, // Техническое задание
  PD: 2, // Проектная документация
  WD: 3, // Рабочая документация
  TSC: 4, // Изменение в техническое задание
  II: 5, // Инженерные изыскания
  PDEdit: 6, // Изменение в ПД
  WDEdit: 7, // Изменение в РД
  IIEdit: 8, // Изменение в ИИ
  OriginalData: 9, // Исходные данные
  IPA: 10,           //исходно- разрешительная документация, Initial Permits and Approvals
  IPAEdit: 11,
  Executive: 12, // Исполнительная документация
}
